import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";

const updateDocument = async (id: string, value: string) => {
  const params = {
    id,
  };
  return await axiosInstance
    .patch(`documents/status/${id}`, { status: value }, { params })
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const mutationFunction = async ({
  id,
  value,
}: {
  id: string;
  value: string;
}) => {
  await updateDocument(id, value);
};

const useUpdateDocumentStatus = () => {
  return useMutation({
    mutationFn: mutationFunction,
    mutationKey: ["documentsUpdate"],
  });
};

export default useUpdateDocumentStatus;
